export default "/_next/static/videos/starten-ef397f5efd3d329d9790e182a0130e8e.mp4";